<script lang="ts" setup>

const props = defineProps<{
  radioId: string
  radioGroup: string
  selectedRadioId?: string | number
  label?: string
  isDisabled?: boolean
}>();

const emits = defineEmits(['set-radio'])

const getRadioValue = computed({
  get() {
    return props.selectedRadioId;
  },
  set() {
    emits('set-radio', props.radioId)
  }
});

</script>

<template>
  <div
    class="radio"
    :class="isDisabled && 'radio-disabled'"
  >
    <label :for="`radio_${radioId}`">
      <input
        v-model="getRadioValue"
        type="radio"
        :id="`radio_${radioId}`"
        :value="radioId"
        :name="radioGroup"
        :checked="Boolean(selectedRadioId)"
      />
      <span class="radio-text">{{ label ? label : '' }}</span>
    </label>
  </div>
</template>

<style lang="scss" scoped>
.radio {
  label {
    cursor: pointer;
    position: relative;
    overflow: hidden;
    input {
      display: none;
      &:checked + span {
        &:before {
          box-shadow: inset 0 0 0 6px $control-bg_primary;
        }
      }
    }
    span {
      @include font(16px, 20px, 400);
      display: flex;
      align-items: center;
      gap: 8px;
      transition: 0.25s ease;
      &:hover:before {
        box-shadow: inset 0 0 0 1px $control-bg_primary;
      }
      &:before {
        display: flex;
        flex-shrink: 0;
        content: "";
        background-color: $control-bg_white;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        transition: 0.25s ease;
        box-shadow: inset 0 0 0 1px $bg_border;
      }
    }
  }

  &-disabled {
    pointer-events: none;
    span:before {
        background-color: $bg_neutral !important;
    }
  }
}
</style>
